<template>
  <div>
    <!--Navbar-->
    <mdb-navbar class='header' position="top" dark color="black" scrolling center>
      <mdb-container>
        <mdb-navbar-toggler style="max-width: 1380px">
          <mdb-navbar-nav class="menu" nav center ml-auto >
            <mdb-nav-item class="logo" to="/#">
              <img class="logo" src="/static/images/logo/logowithtext3.png" alt="">
            </mdb-nav-item>
            <mdb-nav-item class="item h5fontstyle" to="/carlistimport">
              <span class="menufontcolor">수입차 가격표</span>
            </mdb-nav-item>
            <mdb-nav-item class="item h5fontstyle" to="/carlistlocal">
              <span class="menufontcolor">국산차 가격표</span>
            </mdb-nav-item>
            <mdb-nav-item class="item h5fontstyle" to="/faq">
              <span class="menufontcolor">FAQ</span>
            </mdb-nav-item>
          </mdb-navbar-nav>
        </mdb-navbar-toggler>
      </mdb-container>
      <a class="phone" href="tel:02-566-3425">
        <mdb-btn class="phoneno btn-lg">
          <img src="/static/images/icons/phone-call.png"/>대표번호  02-566-3425
        </mdb-btn>
      </a>
    </mdb-navbar>
    <!--/.Navbar-->
  </div>
</template>

<script>
export default {
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo {
  max-width: 380px;
  max-height: 42px;
  margin-top: -5px;
  margin-right: 40px;
}

.menufontcolor{
  color:white;
}

.header {
  background-color: rgba(37, 37, 37, 0.7);
  color: rgb(0, 0, 0);
  opacity: 0.9;
  max-width: 1900px;
  height: auto;
}

.btn.btn-lg {
  padding: 0 0px;
  font-size: .94rem;
  margin: 0 0px;
}

.h5fontstyle {
  font-size: 20px;
  font-weight: 600;
  font-family: 'Nanum Square','Nanum Gothic', 'Noto Sans KR',
      'Malgun Gothic', 'Roboto', Arial, Dotum, Gulim, Verdana, Tahoma;
  margin-right: 20px;
}

.item {
  font-size: 20px;
  font-weight: 600;
  font-family: 'Nanum Square','Nanum Gothic', 'Noto Sans KR',
      'Malgun Gothic', 'Roboto', Arial, Dotum, Gulim, Verdana, Tahoma;
  text-align: center;
  display: inline-block;
  margin-bottom: 0;
  align-items: center;
  margin-right: 20px;
}

a.nav-link {
  color: white;
}

.nav-link {
    display: block;
    padding: 0rem 1.3rem;
}

.item :hover {
  color: #ffba00;
  border-bottom: 0px solid #ffba00;
}

.top-nav-collapse {
  background-color: #000000 !important;
  max-width: 1900px;
}

@media (max-width: 1180px){
  .navbar {
    background-color: #000000 !important;
    max-height: 35px;
    max-width: 1180px;
  }
}

@media (min-width: 600px) {
  .navbar.scrolling-navbar {
      padding-top: 12px;
      padding-bottom: 12px;
      -webkit-transition: background 0.5s ease-in-out,padding 0.5s ease-in-out;
      transition: background 0.5s ease-in-out,padding 0.5s ease-in-out;
  }
}

.phone img{
  max-width: 30px;
  max-height: 25px;
  margin-left: 5px;
  margin-right: 5px;
}
.phone{
  background-color:transparent;
  color:white;
  font-size: 14px;
  max-width: 300px;
  margin-right: 13%;
}

.phoneno{
  background-color:transparent;
  color:white;
  font-size: 14px;
  max-width: 300px;
  margin-left: 0px;
}

.btn-secondary {
    color: #fff;
    background-color: transparent !important;
}

.btn-secondary :hover{
    color: #fff;
    background-color: black !important;
}

.btn-secondary :active{
    color: #fff;
    background-color: black !important;
}

.phone :active{
  background-color: transparent;
}

.btn-default {
  color: #fff;
  background-color: black !important;
}

.btn-default :hover {
  color: #fff;
  background-color: black !important;
}

.btn-default :active {
  color: #fff;
  background-color: black !important;
}
</style>
